import { t, localePrefix } from "@/helper/helper";
import Link from "next/link";
import { useRouter } from "next/router";
import { parseCookies } from "nookies";
import React from "react";
import styled from "styled-components";

interface Props {
  locale: string;
  login: boolean;
}

export default function EmptyCart({ locale, login }: Props) {
  const { push } = useRouter();

  const handleGoShopping = () => {
    push(`${locale}/`);
  };

  return (
    <Wrapper>
      <div className="empty-cart">
        <div className="empty-cart__header">
          <div className="empty-cart__ellipse">
            <img
              src={require("@/assets/img/emptyCart.svg").default.src}
              alt="Empty Cart"
            />
          </div>
        </div>
        <div className="empty-cart__title">{t("cartIsEmpty", locale)}</div>
        <div className="empty-cart__description">
          {t("cartDescription", locale)}
          {!login ? (
            <Link
              className="empty-cart__link"
              href={login ? `${locale}/account` : `${localePrefix(locale)}/login`}
            >
              {" "}
              {t("login", locale)}
            </Link>
          ) : (
            <></>
          )}
        </div>
        <button className="empty-cart__shopping-btn" onClick={handleGoShopping}>
          {t("doShopping", locale)}
        </button>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .empty-cart {
    margin-top: 36px;
    padding: 72px;
    background-color: rgba(208, 212, 222, 0.25);
    border-radius: 12px;
  }
  .empty-cart__ellipse {
    width: 260px;
    height: 198.59px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 23px;
  }
  .empty-cart__title {
    font-family: "Nunito";
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    color: #1b1c1f;
    text-align: center;
    margin-bottom: 12px;
  }
  .empty-cart__description {
    font-family: "Nunito";
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 16px;
    color: #444444;
    text-align: center;
    margin-bottom: 36px;
  }
  .empty-cart__link {
    color: #ff4c4c;
  }
  .empty-cart__shopping-btn {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 23.6rem;
    height: 6rem;
    background: #ff4c4c;
    border-radius: 6px;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 24px;
    color: #ffffff;
    margin-top: 2.4rem;
  }
`;
